import React, {useRef} from 'react'
import useStyles from "./styles";
import {useOnClickOutside} from "../../hooks/useClickOutside";

export const Menu = ({ onChange, isOpened, children, menuActivator }) => {
    const classes = useStyles();
    const menuRef = useRef(null);

    useOnClickOutside(menuRef, () => onChange(false));
    return (
        <div className={classes.wrapper} ref={menuRef}>
            {menuActivator}
            {isOpened && (
                <div className={classes.menu}>
                    {children}
                </div>
            )}
        </div>
    )
}
